import { HelpButtonConfig } from '../../../components/shared/data-table/data-table.config';
import type { PickupConfig } from './pickup.types';

export const PICKUP_CONFIG: PickupConfig = {
  routePath: 'pickup/assign',
  targetTableButtons: [HelpButtonConfig(0)],
  targetTableColumns: [
    {
      name: 'Progress',
      key: 'pickupAssignFlgMessage',
      style: { color: 'red' },
      styleMap: {
        배정완료: { color: '#0087ff' },
      },
    },
    { key: 'carGoodsNm', name: 'carGoodsNm' },
    { key: 'startDate', name: 'Departure Date' },
    {
      key: 'departingDestinationPoint',
      name: 'Departure Arrival Point',
    },
    {
      key: 'departingAirplaneCode',
      name: 'Departure Flight',
    },
    {
      key: 'departingDestinationTime',
      name: 'Departure Arrival Time',
    },
    {
      key: 'returnDate',
      name: 'Return Date',
    },
    {
      key: 'returnStartPoint',
      name: 'Return Start Point',
    },
    {
      key: 'returnAirplaneCode',
      name: 'Return Flight',
    },
    {
      key: 'returnStartTime',
      name: 'Return Start Time',
    },
    {
      name: 'Number of People',
      key: 'activeTourNumber',
      center: true,
    },
    {
      key: 'bookingTitle',
      name: 'common.title',
    },
  ],
};
